export const FIELD_POSITIONS = {
  sectionName: { row: { position: 0 }, col: { position: 1, span: 12 } },
  signedSampleAvailable: { row: { position: 1 }, col: { position: 1 } },
  'appearance.optional': { row: { position: 2 }, col: { position: 1 } },
  'accessories.optional': { row: { position: 2 }, col: { position: 2 } },
  'material.optional': { row: { position: 3 }, col: { position: 1 } },
  'package.optional': { row: { position: 3 }, col: { position: 2 } },
  'labelling.optional': { row: { position: 4 }, col: { position: 1 } },
  'result.optional': { row: { position: 5 }, col: { position: 1 } },
  'remark.optional': { row: { position: 6 }, col: { position: 1 } },
  'referenceMedia.optional': { row: { position: 6 }, col: { position: 2 } },
};

export const initValue = (fields, configs) => {
  return fields.reduce((acc, field) => {
    const { name } = field;
    const config = configs.find((c) => c.fieldName === name);
    if (config) {
      return {
        ...acc,
        [name]: {
          [config.name]: field[config.name],
        },
      };
    }
    return acc;
  }, {});
};
